import { getInboxCounts } from '@/lib/inbox-api';
import { useLoader } from '@/hooks/use-loader';
import { useTaskStore } from '@/stores/taskStore';
import { SidebarMenuBadge } from '@/components/ui/sidebar';
import { cn } from '@/lib/utils';

/** Unassigned, open conversations in the Inbox lane, beside the Inbox nav link. Refreshes live. */
export function InboxNavBadge({ className }: { className?: string } = {}) {
  const tick = useTaskStore((s) => s.inboxTick);
  const { data } = useLoader(() => getInboxCounts(), [tick]);
  const unassigned = data?.data?.counts?.unassigned ?? 0;
  if (!unassigned) return null;
  return (
    // Styled like the Tasks count above it (TasksNavBadge): a quiet number, not a coloured pill.
    <SidebarMenuBadge
      className={cn('text-muted-foreground', className)}
      data-hint="Unassigned and open"
      aria-label={`${unassigned} unassigned open conversations`}
    >
      {unassigned}
    </SidebarMenuBadge>
  );
}
